import { useAllCheckpointsState } from 'screens/Admin/ProjectCheckpoints/hooks/useAllCheckpointsState'
import { IProjectCheckpoint } from 'screens/Admin/ProjectCheckpoints/projectCheckpoints.types'
import Dropdown from 'shared/Inputs/Dropdown'

interface IProps {
  options: IProjectCheckpoint[]
  value: string[] | undefined
  name: string
  onChange: (val: string[], name: string) => void
}

const FaqCheckpointSelect = (props: IProps) => {
  const { checkpointsMap } = useAllCheckpointsState()

  const handleSelect = (val: IProjectCheckpoint[]) => {
    props.onChange(
      val.map((v) => v.id),
      props.name
    )
  }

  const selected = props.value?.map((v) => checkpointsMap[v]) ?? []

  return (
    <Dropdown
      options={props.options}
      selectedOption={selected}
      title='Контрольные точки'
      onSelect={handleSelect}
      getOptionKey={(o) => o?.id}
      getOptionLabel={(o) => o?.name}
      multiple
      limitTags={1}
    />
  )
}

export default FaqCheckpointSelect
